// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Export Button Styles */

.export-button-container {
  position: relative;
  display: inline-block;
}

.export-button-container .btn-group {
  display: flex;
  position: relative;
  gap: 0;
}

.export-button-container .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding: 8px 14px;
  font-size: 0.95rem;
  border-radius: 4px;
  border: 1px solid transparent;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.export-button-container .btn.btn-primary {
  background-color: #0d6efd;
  color: white;
  border-color: #0d6efd;
}

.export-button-container .btn.btn-primary:hover:not(:disabled) {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.export-button-container .btn.btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.export-button-container .btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.export-button-container .btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 8px 10px;
  min-width: 35px;
  justify-content: center;
}

.export-button-container .btn svg {
  flex-shrink: 0;
}

/* Dropdown Menu */
.export-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  margin-top: 4px;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.export-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: none;
  color: #2c3e50;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  font-weight: 500;
}

.export-dropdown .dropdown-item:first-child {
  border-radius: 4px 4px 0 0;
}

.export-dropdown .dropdown-item:last-child {
  border-radius: 0 0 4px 4px;
}

.export-dropdown .dropdown-item:hover:not(:disabled) {
  background-color: #f8f9fa;
  color: #0d6efd;
  padding-left: 16px;
}

.export-dropdown .dropdown-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.export-dropdown .dropdown-item svg {
  flex-shrink: 0;
}

.export-dropdown .dropdown-item span {
  flex-grow: 1;
}

/* Loading State */
.export-button-container .spinner-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 576px) {
  .export-button-container .btn {
    padding: 6px 10px;
    font-size: 0.85rem;
  }

  .export-button-container .btn:first-child {
    padding: 6px 10px;
  }

  .export-button-container .btn span {
    display: none;
  }

  .export-dropdown {
    min-width: 150px;
  }

  .export-dropdown .dropdown-item {
    padding: 8px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditFindings/ExportButton.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Export Button Styles */\n\n.export-button-container {\n  position: relative;\n  display: inline-block;\n}\n\n.export-button-container .btn-group {\n  display: flex;\n  position: relative;\n  gap: 0;\n}\n\n.export-button-container .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  padding: 8px 14px;\n  font-size: 0.95rem;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.export-button-container .btn.btn-primary {\n  background-color: #0d6efd;\n  color: white;\n  border-color: #0d6efd;\n}\n\n.export-button-container .btn.btn-primary:hover:not(:disabled) {\n  background-color: #0b5ed7;\n  border-color: #0a58ca;\n}\n\n.export-button-container .btn.btn-primary:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.export-button-container .btn:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.export-button-container .btn:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 8px 10px;\n  min-width: 35px;\n  justify-content: center;\n}\n\n.export-button-container .btn svg {\n  flex-shrink: 0;\n}\n\n/* Dropdown Menu */\n.export-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 180px;\n  z-index: 1000;\n  margin-top: 4px;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.export-dropdown .dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  color: #2c3e50;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.export-dropdown .dropdown-item:first-child {\n  border-radius: 4px 4px 0 0;\n}\n\n.export-dropdown .dropdown-item:last-child {\n  border-radius: 0 0 4px 4px;\n}\n\n.export-dropdown .dropdown-item:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  color: #0d6efd;\n  padding-left: 16px;\n}\n\n.export-dropdown .dropdown-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.export-dropdown .dropdown-item svg {\n  flex-shrink: 0;\n}\n\n.export-dropdown .dropdown-item span {\n  flex-grow: 1;\n}\n\n/* Loading State */\n.export-button-container .spinner-icon {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 576px) {\n  .export-button-container .btn {\n    padding: 6px 10px;\n    font-size: 0.85rem;\n  }\n\n  .export-button-container .btn:first-child {\n    padding: 6px 10px;\n  }\n\n  .export-button-container .btn span {\n    display: none;\n  }\n\n  .export-dropdown {\n    min-width: 150px;\n  }\n\n  .export-dropdown .dropdown-item {\n    padding: 8px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
